/** GENERATED by scripts/brand.mjs from brand/palette.json — do not edit. */
export const PRODUCT_NAME = 'Railit';
export const PRODUCT_DOMAIN = 'railit.ai';
export const PRODUCT_URL = 'https://railit.ai';
export const TAGLINE_EN = 'Keep the books on rails.';
export const TAGLINE_AR = 'دفاترك على السكة.';
